import { render, staticRenderFns } from "./CoachRegister.vue?vue&type=template&id=8735e4d4&scoped=true&"
import script from "./CoachRegister.vue?vue&type=script&lang=js&"
export * from "./CoachRegister.vue?vue&type=script&lang=js&"
import style0 from "./CoachRegister.vue?vue&type=style&index=0&id=8735e4d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8735e4d4",
  null
  
)

export default component.exports